module.exports = __webpack_public_path__ + "aaee442dc0d77087b8e5a3fee6b6ce50.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-22.png
// module id = 2668
// module chunks = 0